var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M14.707 3.293a1 1 0 0 1 0 1.414L6 13.414 2.293 9.707a1 1 0 0 1 1.414-1.414L6 10.586l7.293-7.293a1 1 0 0 1 1.414 0z"}));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
